// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "accesspolicy/internalapi/v1/accesspolicy.proto" (package "accesspolicy.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs backing the access policy editor on machines and fragments: the
// API method catalog grants are authored against, and the subjects a grant can name.
//
// Every RPC is gated behind the ENABLE_ACCESS_POLICY feature flag for the
// organization it reads. Nothing here writes: the editor saves grants through the
// part's or fragment's config like any other config section.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.GetAPICatalogRequest
 */
export interface GetAPICatalogRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.GetAPICatalogResponse
 */
export interface GetAPICatalogResponse {
    /**
     * @generated from protobuf field: repeated accesspolicy.internalapi.v1.APIService services = 1;
     */
    services: APIService[];
    /**
     * baseline_methods are the "_machine" methods a grant with basic_connection
     * turned on grants. Without them no client can connect.
     *
     * @generated from protobuf field: repeated string baseline_methods = 2;
     */
    baselineMethods: string[];
    /**
     * machine_service is the service whose methods are granted on "_machine".
     *
     * @generated from protobuf field: string machine_service = 3;
     */
    machineService: string;
}
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.APIService
 */
export interface APIService {
    /**
     * name is the fully qualified proto service, e.g.
     * "viam.component.camera.v1.CameraService".
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * resource_api is the RDK API triplet the service serves, e.g.
     * "rdk:component:camera". Empty for services not backed by a named resource.
     *
     * @generated from protobuf field: string resource_api = 3;
     */
    resourceApi: string;
    /**
     * @generated from protobuf field: repeated accesspolicy.internalapi.v1.APIMethod methods = 4;
     */
    methods: APIMethod[];
    /**
     * bundled_methods are granted on a resource alongside any of this service's
     * methods, e.g. stream management for a camera.
     *
     * @generated from protobuf field: repeated string bundled_methods = 5;
     */
    bundledMethods: string[];
    /**
     * machine_bundled_methods are granted on "_machine" alongside any of this
     * service's methods, because viam-server does not scope them to a resource.
     *
     * @generated from protobuf field: repeated string machine_bundled_methods = 6;
     */
    machineBundledMethods: string[];
    /**
     * @generated from protobuf field: string warning = 7;
     */
    warning: string;
}
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.APIMethod
 */
export interface APIMethod {
    /**
     * method is the fully qualified gRPC method, e.g.
     * "/viam.component.camera.v1.CameraService/GetImages".
     *
     * @generated from protobuf field: string method = 1;
     */
    method: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * dangerous_by_default flags a method the editor warns about before granting.
     * A "*" wildcard still includes it.
     *
     * @generated from protobuf field: bool dangerous_by_default = 3;
     */
    dangerousByDefault: boolean;
    /**
     * @generated from protobuf field: string warning = 4;
     */
    warning: string;
}
/**
 * AccessSubject is one identity a grant names. type is "app-user-id" or
 * "api-key-id"; id is the user's or API key's ID.
 *
 * @generated from protobuf message accesspolicy.internalapi.v1.AccessSubject
 */
export interface AccessSubject {
    /**
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.ListGrantSubjectsRequest
 */
export interface ListGrantSubjectsRequest {
    /**
     * @generated from protobuf oneof: scope
     */
    scope: {
        oneofKind: "partId";
        /**
         * @generated from protobuf field: string part_id = 1;
         */
        partId: string;
    } | {
        oneofKind: "fragmentId";
        /**
         * A fragment's grants bind wherever it is imported, so its members are
         * everyone holding the member role anywhere in the fragment's organization.
         *
         * @generated from protobuf field: string fragment_id = 3;
         */
        fragmentId: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * subjects are subjects the grants already name, to label and classify whether
     * or not they are still members.
     *
     * @generated from protobuf field: repeated accesspolicy.internalapi.v1.AccessSubject subjects = 2;
     */
    subjects: AccessSubject[];
}
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.ListGrantSubjectsResponse
 */
export interface ListGrantSubjectsResponse {
    /**
     * subjects are the scope's members ordered by label, then every requested
     * subject that is not a member, each listed once.
     *
     * @generated from protobuf field: repeated accesspolicy.internalapi.v1.GrantSubject subjects = 1;
     */
    subjects: GrantSubject[];
}
/**
 * @generated from protobuf message accesspolicy.internalapi.v1.GrantSubject
 */
export interface GrantSubject {
    /**
     * @generated from protobuf field: accesspolicy.internalapi.v1.AccessSubject subject = 1;
     */
    subject?: AccessSubject;
    /**
     * label is a user's email or an API key's name. Empty when the caller cannot see
     * the subject in the organization, or when there is nothing to show: a user with
     * no email, or an API key with no name.
     *
     * @generated from protobuf field: string label = 2;
     */
    label: string;
    /**
     * @generated from protobuf field: accesspolicy.internalapi.v1.GrantSubjectStatus status = 3;
     */
    status: GrantSubjectStatus;
}
/**
 * @generated from protobuf enum accesspolicy.internalapi.v1.GrantSubjectStatus
 */
export enum GrantSubjectStatus {
    /**
     * @generated from protobuf enum value: GRANT_SUBJECT_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * MEMBER subjects hold the member role in the scope, so grants naming them apply.
     *
     * @generated from protobuf enum value: GRANT_SUBJECT_STATUS_MEMBER = 1;
     */
    MEMBER = 1,
    /**
     * FULL_ACCESS subjects own or operate wherever they hold a role, so they already
     * reach every method there.
     *
     * @generated from protobuf enum value: GRANT_SUBJECT_STATUS_FULL_ACCESS = 2;
     */
    FULL_ACCESS = 2,
    /**
     * NO_ROLE subjects hold no role in the scope, so grants naming them lapse.
     *
     * @generated from protobuf enum value: GRANT_SUBJECT_STATUS_NO_ROLE = 3;
     */
    NO_ROLE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class GetAPICatalogRequest$Type extends MessageType<GetAPICatalogRequest> {
    constructor() {
        super("accesspolicy.internalapi.v1.GetAPICatalogRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.GetAPICatalogRequest
 */
export const GetAPICatalogRequest = new GetAPICatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAPICatalogResponse$Type extends MessageType<GetAPICatalogResponse> {
    constructor() {
        super("accesspolicy.internalapi.v1.GetAPICatalogResponse", [
            { no: 1, name: "services", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIService },
            { no: 2, name: "baseline_methods", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "machine_service", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.GetAPICatalogResponse
 */
export const GetAPICatalogResponse = new GetAPICatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIService$Type extends MessageType<APIService> {
    constructor() {
        super("accesspolicy.internalapi.v1.APIService", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_api", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "methods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIMethod },
            { no: 5, name: "bundled_methods", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "machine_bundled_methods", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "warning", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.APIService
 */
export const APIService = new APIService$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIMethod$Type extends MessageType<APIMethod> {
    constructor() {
        super("accesspolicy.internalapi.v1.APIMethod", [
            { no: 1, name: "method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dangerous_by_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "warning", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.APIMethod
 */
export const APIMethod = new APIMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessSubject$Type extends MessageType<AccessSubject> {
    constructor() {
        super("accesspolicy.internalapi.v1.AccessSubject", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.AccessSubject
 */
export const AccessSubject = new AccessSubject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGrantSubjectsRequest$Type extends MessageType<ListGrantSubjectsRequest> {
    constructor() {
        super("accesspolicy.internalapi.v1.ListGrantSubjectsRequest", [
            { no: 1, name: "part_id", kind: "scalar", oneof: "scope", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fragment_id", kind: "scalar", oneof: "scope", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subjects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessSubject }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.ListGrantSubjectsRequest
 */
export const ListGrantSubjectsRequest = new ListGrantSubjectsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGrantSubjectsResponse$Type extends MessageType<ListGrantSubjectsResponse> {
    constructor() {
        super("accesspolicy.internalapi.v1.ListGrantSubjectsResponse", [
            { no: 1, name: "subjects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantSubject }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.ListGrantSubjectsResponse
 */
export const ListGrantSubjectsResponse = new ListGrantSubjectsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantSubject$Type extends MessageType<GrantSubject> {
    constructor() {
        super("accesspolicy.internalapi.v1.GrantSubject", [
            { no: 1, name: "subject", kind: "message", T: () => AccessSubject },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["accesspolicy.internalapi.v1.GrantSubjectStatus", GrantSubjectStatus, "GRANT_SUBJECT_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message accesspolicy.internalapi.v1.GrantSubject
 */
export const GrantSubject = new GrantSubject$Type();
/**
 * @generated ServiceType for protobuf service accesspolicy.internalapi.v1.InternalAccessPolicyService
 */
export const InternalAccessPolicyService = new ServiceType("accesspolicy.internalapi.v1.InternalAccessPolicyService", [
    { name: "GetAPICatalog", options: {}, I: GetAPICatalogRequest, O: GetAPICatalogResponse },
    { name: "ListGrantSubjects", options: {}, I: ListGrantSubjectsRequest, O: ListGrantSubjectsResponse }
]);
